import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

type LocationFilter = {
  coordinates: {
    longitude: number;
    latitude: number;
  } | null;
  layers: string[];
};

interface RoutePanelState {
  locationFilter: LocationFilter;
  locationFilterLoading: boolean;
  locationFilterError: boolean;
  searchFilterValue: string;
}

export const INITIAL_ROUTES_PANEL_STATE: RoutePanelState = {
  locationFilter: {
    coordinates: null,
    layers: [],
  },
  locationFilterLoading: false,
  locationFilterError: false,
  searchFilterValue: '',
};

const RoutesPanelSlice = createSlice({
  name: 'routesPanel',
  initialState: INITIAL_ROUTES_PANEL_STATE,
  reducers: {
    setSearchFilterValue: (state, action: PayloadAction<string>) => {
      state.searchFilterValue = action.payload;
    },
  },
});

export const { setSearchFilterValue } = RoutesPanelSlice.actions;

export default RoutesPanelSlice.reducer;
